module.exports = __webpack_public_path__ + "media/images/old_logos/favicon-fe45b8ac4af8c9f21d8c126637562c27.ico";